import Photo from "./Photo";

export default class Scan extends Photo {
  descriptor: MouthDescriptor;

  static orderByDescriptor(descriptorOrderList: MouthDescriptor[]): (a: Scan, b: Scan) => number {
    const descriptorOrder = descriptorOrderList.reduce((acc, elt, i) => ((acc[elt] = i), acc), {});

    return (a: Scan, b: Scan) => {
      return descriptorOrder[a.descriptor] - descriptorOrder[b.descriptor];
    };
  }
}

export enum MouthDescriptor {
  OPENED_TOP = "OPENED_TOP",
  OPENED_BOTTOM = "OPENED_BOTTOM",
  CLOSED_LEFT = "CLOSED_LEFT",
  CLOSED_FRONT = "CLOSED_FRONT",
  CLOSED_RIGHT = "CLOSED_RIGHT",
  SLIGHTLY_OPENED_LEFT = "SLIGHTLY_OPENED_LEFT",
  SLIGHTLY_OPENED_FRONT_LEFT = "SLIGHTLY_OPENED_FRONT_LEFT",
  SLIGHTLY_OPENED_FRONT = "SLIGHTLY_OPENED_FRONT",
  SLIGHTLY_OPENED_FRONT_RIGHT = "SLIGHTLY_OPENED_FRONT_RIGHT",
  SLIGHTLY_OPENED_RIGHT = "SLIGHTLY_OPENED_RIGHT",

  FACE_SMILING = "FACE_SMILING",
  FACE_SMILING_CORRECTED = "FACE_SMILING_CORRECTED",
  FACE_SMILING_WITH_WHITENING = "FACE_SMILING_WITH_WHITENING",
  FACE_SMILING_AFTER_TREATMENT = "FACE_SMILING_AFTER_TREATMENT",
  FACE_SMILING_AFTER_TREATMENT_WITH_WHITENING = "FACE_SMILING_AFTER_TREATMENT_WITH_WHITENING",
  FACE_MOUTH_SLIGHTLY_OPENED = "FACE_MOUTH_SLIGHTLY_OPENED",
  FACE_MOUTH_SLIGHTLY_OPENED_CORRECTED = "FACE_MOUTH_SLIGHTLY_OPENED_CORRECTED",
  FACE_MOUTH_SLIGHTLY_OPENED_ALIGNERS = "FACE_MOUTH_SLIGHTLY_OPENED_ALIGNERS",
  FACE_MOUTH_SLIGHTLY_OPENED_CERAMIC_BRACES = "FACE_MOUTH_SLIGHTLY_OPENED_CERAMIC_BRACES",
  FACE_MOUTH_SLIGHTLY_OPENED_SELF_LIGATING_BRACES = "FACE_MOUTH_SLIGHTLY_OPENED_SELF_LIGATING_BRACES",
  FACE_MOUTH_SLIGHTLY_OPENED_METALLIC_BRACES = "FACE_MOUTH_SLIGHTLY_OPENED_METALLIC_BRACES",
}

export const getI18nMouthDescription = (mouthDescriptor: MouthDescriptor) => {
  switch (mouthDescriptor) {
    case MouthDescriptor.SLIGHTLY_OPENED_LEFT:
      return "ScanPackage.SlightlyOpened.Left";
    case MouthDescriptor.SLIGHTLY_OPENED_FRONT_LEFT:
      return "ScanPackage.SlightlyOpened.FrontLeft";
    case MouthDescriptor.SLIGHTLY_OPENED_FRONT:
      return "ScanPackage.SlightlyOpened.Front";
    case MouthDescriptor.SLIGHTLY_OPENED_FRONT_RIGHT:
      return "ScanPackage.SlightlyOpened.FrontRight";
    case MouthDescriptor.SLIGHTLY_OPENED_RIGHT:
      return "ScanPackage.SlightlyOpened.Right";
    case MouthDescriptor.CLOSED_FRONT:
      return "ScanPackage.Closed.Front";
    case MouthDescriptor.CLOSED_LEFT:
      return "ScanPackage.Closed.Left";
    case MouthDescriptor.CLOSED_RIGHT:
      return "ScanPackage.Closed.Right";
    case MouthDescriptor.OPENED_BOTTOM:
      return "ScanPackage.Opened.Bottom";
    case MouthDescriptor.OPENED_TOP:
      return "ScanPackage.Opened.Top";
    case MouthDescriptor.FACE_SMILING:
      return "ScanPackages.Face.Smiling";
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED:
      return "ScanPackages.Face.MouthSlightlyOpened";
    case MouthDescriptor.FACE_SMILING_AFTER_TREATMENT:
      return "ScanPackages.Face.SmilingAfterTreatment";
    case MouthDescriptor.FACE_SMILING_AFTER_TREATMENT_WITH_WHITENING:
      return "ScanPackages.Face.SmilingAfterTreatmentWithWhitening";
    case MouthDescriptor.FACE_SMILING_WITH_WHITENING:
      return "ScanPackages.Face.SmilingWithWhitening";
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_ALIGNERS:
      return "ScanPackages.Face.MouthSlightlyOpenedAligners";
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_CERAMIC_BRACES:
      return "ScanPackages.Face.MouthSlightlyOpenedCeramicBraces";
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_SELF_LIGATING_BRACES:
      return "ScanPackages.Face.MouthSlightlyOpenedSelfLigatingBraces";
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_METALLIC_BRACES:
      return "ScanPackages.Face.MouthSlightlyOpenedMetallicBraces";
  }
};

export const SmileWithApplianceDescriptors: MouthDescriptor[] = [
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_ALIGNERS,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_METALLIC_BRACES,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_SELF_LIGATING_BRACES,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_CERAMIC_BRACES,
];

export const SmilePredictionDescriptors: MouthDescriptor[] = [
  MouthDescriptor.FACE_SMILING_AFTER_TREATMENT,
  MouthDescriptor.FACE_SMILING_WITH_WHITENING,
  MouthDescriptor.FACE_SMILING_AFTER_TREATMENT_WITH_WHITENING,
];

export const FaceDescriptors: MouthDescriptor[] = [
  MouthDescriptor.FACE_SMILING,
  MouthDescriptor.FACE_SMILING_WITH_WHITENING,
  MouthDescriptor.FACE_SMILING_AFTER_TREATMENT,
  MouthDescriptor.FACE_SMILING_AFTER_TREATMENT_WITH_WHITENING,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_ALIGNERS,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_CERAMIC_BRACES,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_SELF_LIGATING_BRACES,
  MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_METALLIC_BRACES,
];

export const PortraitDescriptors: MouthDescriptor[] = FaceDescriptors;

export const LandscapeDescriptors: MouthDescriptor[] = [
  MouthDescriptor.OPENED_TOP,
  MouthDescriptor.OPENED_BOTTOM,
  MouthDescriptor.CLOSED_LEFT,
  MouthDescriptor.CLOSED_FRONT,
  MouthDescriptor.CLOSED_RIGHT,
  MouthDescriptor.SLIGHTLY_OPENED_LEFT,
  MouthDescriptor.SLIGHTLY_OPENED_FRONT_LEFT,
  MouthDescriptor.SLIGHTLY_OPENED_FRONT,
  MouthDescriptor.SLIGHTLY_OPENED_FRONT_RIGHT,
  MouthDescriptor.SLIGHTLY_OPENED_RIGHT,
];
